module.exports = __webpack_public_path__ + "static/media/logo_jht_white.79e52898.png";